export function array_value(input) {
  const tmpArr = [];
  let key = "";
  for (key in input) {
    tmpArr[tmpArr.length] = input[key];
  }
  return tmpArr;
}
